import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import _ from 'lodash';
import styled from 'styled-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  AlignedGrid, QuoteComparisonExpansionPanel, createLoanGridElements, createLoanGridLabel,
  createLoanGridElementsWithRenderer,
  createMoneyLoanGridElements,
  createPeriodLoanGridElements,
  QuoteComparisonExpansionSummary,QuoteComparisonExpansionPanelDetails,createMultiLineStringLoanGridElements,
} from './QuoteComparisonGridElements';
import numberFormatter from 'utils/numberFormatter';
export const RightAlignedDiv = styled.div`
  text-align:right;
`
class InterestOnlyPeriod extends Component {
  state = {
    expanded:true
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }

  renderAmortization = (property) => {
    return (loan) => {
      let value = _.get(loan, property);
      if(!value && value !== 0)
        return (<RightAlignedDiv>Interest Only</RightAlignedDiv>);
      if(value / 12 < 1)
        return `${value} Months`;
      return `${(value /12).toFixed(0)} Years`;
    }
  }

  render() {
    const { loans, isCombined} = this.props;
    const { expanded } = this.state;
    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />} expanded={expanded}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("I/O Periods")}
            {expanded && (!isCombined ? createPeriodLoanGridElements(loans, 'ioPeriod',isCombined) : createMultiLineStringLoanGridElements(loans, 'ioPeriodString', '\u2014',isCombined))}
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            {createLoanGridLabel("Amortization")}
            {!isCombined ? createLoanGridElements(loans, 'amortizationString', '\u2014',isCombined) : createMultiLineStringLoanGridElements(loans, 'amortizationString', '\u2014',isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("I/O Payment")}
            {createMoneyLoanGridElements(loans, 'ioPayment',isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Amortizing Payment")}
            {createMoneyLoanGridElements(loans, 'amortizingPayment',isCombined)}
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default InterestOnlyPeriod;